<template>
  <div>
    <h3>Conversations en cours</h3>
    <mdb-list-group v-if="conversations.length > 0">
      <a @click="select(c)" v-for="c in conversations" :key="c.id">
        <mdb-list-group-item>
          <p class="question">{{c.question}}</p>
          <div class="names">
            <mdb-badge pill :color="getColor(c,user.id)">{{getText(c,user.id)}}</mdb-badge>
            <mdb-badge
              pill
              :color="getColor(c,u)"
              v-for="u in c.between.filter(uid => uid !== user.id)"
              :key="c.id + '-' + u"
            >{{usersRef[u].displayName}}</mdb-badge>
          </div>
        </mdb-list-group-item>
      </a>
    </mdb-list-group>
    <span v-else>Vous n'avez pas encore de conversations</span>
  </div>
</template>

<script>
import { mdbListGroup, mdbListGroupItem, mdbBadge } from "mdbvue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "MyConversations",
  components: {
    mdbListGroup,
    mdbListGroupItem,
    mdbBadge
  },
  computed: {
    ...mapState("conversations", ["conversations"]),
    ...mapState("social", ["usersRef"]),
    ...mapState("db", ["user"]),
  },
  methods: {
    select: function(conv) {
      this.$router.push({
        name: "conversationchat",
        params: {
          conversationId: conv.id
        }
      });
    },
    getColor: function(conv, u) {
      if (conv.hasWritten && conv.hasWritten.includes(u)) {
        return "success";
      }
      return "grey";
    },
    getText: function(conv, u) {
      if (conv.hasWritten && conv.hasWritten.includes(u)) {
        return "Répondu";
      }
      return "En cours...";
    }
  }
};
</script>
<style lang="scss" scoped>
.question{
  text-align: left;
}
.names {
  font-size: 0.8rem;
  margin-left: 5px;
  display: inline-block;
}
.badge {
  margin-left: 5px;
}
</style>